import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const MapClickHandler = ({ onMapClick }) => {
  useMapEvents({
    click(e) {
      onMapClick(e.latlng);
    },
  });
  return null;
};

const MapSelector = ({ onLocationSelected }) => {
  const [marker, setMarker] = React.useState(null);

  const handleClick = async (latlng) => {
    setMarker(latlng);
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latlng.lat}&lon=${latlng.lng}&addressdetails=1`
      );
      const data = await res.json();
      const address = data.address;

      const placeName =
        address.village ||
        address.town ||
        address.city ||
        address.hamlet ||
        address.county ||
        "Unknown Place";

      const landmark =
        address.neighbourhood ||
        address.suburb ||
        address.road ||
        address.locality ||
        "";

      const pin = address.postcode || "";
      const state = address.state || "";

      const formatted = `${placeName}${landmark ? ', near ' + landmark : ''}${pin ? ', ' + pin : ''}${state ? ', ' + state : ''}`;

      onLocationSelected(formatted, latlng);
    } catch (err) {
      console.error("Error fetching map address:", err);
      onLocationSelected("Unknown location", latlng);
    }
  };

  return (
    <div style={{ height: '300px', marginTop: '10px' }}>
      <MapContainer center={[11.95, 79.62]} zoom={13} style={{ height: '100%' }}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapClickHandler onMapClick={handleClick} />
        {marker && <Marker position={marker} />}
      </MapContainer>
    </div>
  );
};

export default MapSelector;
